import script from './checkbox-button.vue_vue_type_script_lang.mjs';
export { default } from './checkbox-button.vue_vue_type_script_lang.mjs';
import { render } from './checkbox-button.vue_vue_type_template_id_f839a66c_lang.mjs';

script.render = render;
script.__file = "packages/components/checkbox/src/checkbox-button.vue";
//# sourceMappingURL=checkbox-button.mjs.map
